export default __webpack_public_path__ + "static/media/cross-browser-logo.1e641de6.svg";